import { jsx as _jsx } from "react/jsx-runtime";
import './Component_HomeTitle.scss';
import { AwaitModules, ComponentSync, Label } from '@nu-art/thunderstorm-frontend/index';
import { FindingData } from '../../../../_utils/FindingData/FindingData.js';
import { AdvisorConfigKeyFE_HomePanel, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { capitalizeAllFirstLetters, filterInstances, sortArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
class Component extends ComponentSync {
    //######################### Static #########################
    static modulesToAwait = [...FindingData.modulesToAwait];
    static loader = () => {
        return _jsx("div", { className: 'c__home-title-loader', children: "Welcome!" });
    };
    //######################### Life Cycle #########################
    __onRuntimeFindingsUpdated = (...params) => this.reDeriveState();
    deriveStateFromProps(nextProps, state) {
        const config = AdvisorConfigKeyFE_HomePanel.get();
        state.age ??= this.getFindingDataForVarId(config?.sections?.hpi?.ageVarId);
        state.gender ??= this.getFindingDataForVarId(config?.sections?.hpi?.genderVarId);
        state.chiefComplaints = this.getCCs();
        return state;
    }
    //######################### Logic #########################
    getFindingDataForVarId(varId) {
        if (!varId)
            return;
        const findings = ModuleFE_RuntimeFinding.cache.filter(f => f.variableId === varId);
        sortArray(findings, f => f.__created, true);
        if (!findings[0])
            return;
        return FindingData.createNew(findings[0]);
    }
    getCCs() {
        return filterInstances(ModuleFE_RuntimeFinding.getChiefComplaints().map(i => FindingData.createNew(i.findingId)));
    }
    resolveTitle = () => {
        const labels = filterInstances([
            this.state.age?.getValue(),
            this.state.gender?.getValue()?.charAt(0).toUpperCase(),
            ...(this.state.chiefComplaints?.map(i => i.getLabel()) ?? [])
        ]);
        return labels.length ? labels.map(i => capitalizeAllFirstLetters(i)).join(', ') : 'Welcome!';
    };
    getContainerSelector = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            return '.home__header';
        return '.advisor-panel__header';
    };
    //######################### Render #########################
    render() {
        return _jsx(Label, { className: 'c__home-title', tooltip: this.render_LabelTT(), containerSelector: this.getContainerSelector(), children: this.resolveTitle() });
    }
    render_LabelTT = () => {
        //Build title
        let title = '';
        if (this.state.age)
            title += `${this.state.age.getValue()}yo `;
        if (this.state.gender)
            title += `${this.state.gender.getValue()}`;
        if (this.state.chiefComplaints?.length) {
            title += '\nChief complaints:\n';
            title += this.state.chiefComplaints.map(i => i.getLabel()).join(', ');
        }
        return title;
    };
}
export const Component_HomeTitle = (p) => _jsx(AwaitModules, { Component: () => _jsx(Component, { ...p }), modules: Component.modulesToAwait, customLoader: Component.loader });
//# sourceMappingURL=Component_HomeTitle.js.map